<div [class.dark]="(darkModeEnabled$ | async) === true
                   && (maintenanceMode$ | async) !== true
                   && (authIsLoading$ | async) !== true"
     class="h-full min-w-[120rem] w-full"
     id="rb-app">
  <ng-container *ngIf="(maintenanceMode$ | async) !== true">
    <rb-auth-container *ngIf="(authIsLoading$ | async) === true"
                       [title]="'AUTH.LOADING'">
      <div class="flex flex-col items-center">
        <mat-spinner class="spinner-brand" diameter="20"></mat-spinner>
      </div>
    </rb-auth-container>
    <router-outlet *ngIf="(authIsLoading$ | async) !== true"></router-outlet>
  </ng-container>
  <rb-maintenance-mode *ngIf="(maintenanceMode$ | async) === true"></rb-maintenance-mode>
</div>
